/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
// import alert from 'react-s-alert';
import * as c from './constant';

export const getRegionsList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    '/api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    '/api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    '/api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangays = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    '/api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const showBarangay = (id, payload, callback) =>
  req.item(
    c.SHOW_BARANGAY,
    `/api/v1/administrators/address/barangays/${id}`,
    payload,
    callback
  );

export const updateBarangay = (id, payload, callback) =>
  req.update(
    c.UPDATE_BARANGAY,
    `/api/v1/administrators/address/barangays/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );
  
  export const clearTransaction = () => req.setList(c.GET_BARANGAYS, []);